export default {
  F: 'F',
  M: 'M',
  X: 'X'
};
